<template>
  <div style="margin-top: 10px">
    <div class="row" v-if="currentValue == null">
      <div class="col-md-12">
        <base-input
          class="input-group-alternative mb-3"
          placeholder="Buscar..."
          addon-left-icon="fa fa-fw fa-search"
          @keyup="buscar()"
          v-model="text"
        ></base-input>
      </div>
      <div class="col-md-12">
        <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
          <div
            class="row"
            v-for="item in items"
            @click="itemClicked(item)"
            v-bind:key="item.ID"
            :value="item.ID"
            style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
          >
            <div class="col-10" style="display: flex">
              <div style="margin-left: 10px;margin-top: 10px;">
                <div>{{item.Text}} {{item.Detail}}</div>
              </div>
            </div>
            <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        class="row"
        style="background-color: white; padding: 5px; border-radius: 5px; margin-right: 0; margin-left: 0; border: #d6d4d4 1px solid"
      >
        <div class="col-10" style="display: flex;">
          <div style="margin-left: 10px;margin-top: 10px;">
            <div>{{currentValue.Text}} {{currentValue.Detail}}</div>
          </div>
        </div>
        <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">
          <i class="fa fa-fw fa-times" style="cursor: pointer" @click="cleanSelected()"></i>
        </div>
      </div>
      <div class="row" style="margin-top: 5px">
        <div class="col-md-12">
          <button @click="cleanSelected" class="btn btn-danger btn-sm" v-if="cleanButton">Limpiar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import notificationHelpers from "@/helpers/notificationHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  props: {
    url: "",
    currentValue: null,
    minLength: {
      type: Number,
      default: 3
    },
    request: {
      type: Object,
       default: () => {
        return {};
      } 
    },
    cleanButton: false
  },
  data() {
    return {
      timer: null,
      text: "",
      items: []
      // selected: null,
    };
  },
  methods: {
    itemClicked(itemSelected) {
      // this.selected = itemSelected;

      this.$emit("input", itemSelected);
    },
    buscar() {
      let context = this;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        if (context.text.length > context.minLength) {
          context.request.Text = context.text;
          axiosHelpers.axiosGet(
            context.url,
            context.request,
            context,
            function(data) {
              // context.movimientos = data.ResponseVM;
              // console.log(data);
              context.items = data.ResponseVM;
            }
          );
        } else {
          context.items = {};
        }
      }, 800);
    },
    cleanSelected() {
      // this.selected = null;

      this.$emit("input", null);
    }
  }
};
</script>